module.exports = __webpack_public_path__ + "static/media/scalable.09d461e3.svg";